import React from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const PostbackHandler = () => {
  const query = useQuery();

  // Read specific query parameters
  const encodedJson = query.get('message');

  // Decode the JSON
  if (encodedJson) {
    const decodedJson = decodeURIComponent(encodedJson);

    // Parse the decoded string back into a JavaScript object
    const jsonObject = JSON.parse(decodedJson);

    Cookies.set('paymentPostBackData', encodedJson);
  }

  return (
    <div>
      <h1>Saving Payment Method Registration details...</h1>
    </div>
  );
};

export default PostbackHandler;
